import React, { useEffect, useState } from 'react';
import './CustomCheckBox.scss';

const CustomCheckbox = React.forwardRef(({
  id,
  onChange,
  checkedImgSrc = '/images/common/CheckboxChecked.svg',
  uncheckedImgSrc = '/images/common/CheckboxUnchecked.svg',
  accept = false
}, ref) => {

  const [checked, setChecked] = useState(false);

  const handleToggle = (event) => {
    setChecked(!checked);
    if (onChange) {
      onChange(!checked, event);
    }
  };

  useEffect(() => {
    setChecked(accept);
  }, [accept])

  return (
    <div className="custom-checkbox">
      <input
        type="checkbox"
        onChange={handleToggle}
        style={{ display: 'none' }}
        id={id ?? 'id-checkbox'}
        ref={ref}
        checked={checked}
      />
      <label htmlFor={id ?? 'id-checkbox'}>
        <img
          src={checked ? checkedImgSrc : uncheckedImgSrc}
          alt={checked ? 'Checked' : 'Unchecked'}
          className="checkbox-image"
        />
      </label>
    </div>
  );
});

export default CustomCheckbox;